// extracted by extract-css-chunks-webpack-plugin
module.exports = {"aligned":"_27qWzk","grid":"_1qhOAs","centered-section-spacing":"_2Jk3_s","grid-odd":"_371X9S","box":"_1MrQ0C","header":"_7-Y2NZ","container":"_2DPhvv"};